import React, { createContext, useReducer, useState } from "react";
import { rankInitialState } from "../components/700/initialStates";
// import { positionReducer } from "../components/700/reducers";
import { rankReducer } from "../components/200/reducers"

const RankContext = createContext();

export function RankContextProvider({ children }) {
  const [rankState, rankDispatch] = useReducer(
    rankReducer,
    rankInitialState
  );
  return (
    <RankContext.Provider
      value={{
        rankState,
        rankDispatch,
      }}
    >
      {children}
    </RankContext.Provider>
  );
}

export default RankContext;
